export const words = {
  place: "مكان",
  yes: "نعم",
  no: "لا",
  new: "الجديد",
  agb: "حيث",
  agb_full: "الشروط والأحكام",
  datenschutzerklaerung: "سياسة الخصوصية",
  status: "حالة",
  company_name: "اسم الشركة",
  next_button: "أبعد",
  device_name: "اسم الجهاز",
  to_connect: "عشق",
  pin: "دبوس",
  time: "الوقت",
  first_name: "اللقب",
  last_name: "اللقب",
  code: "رمز",
  help: "تعليمات",
  total_time: "مجموع",
  latitude: "العرض",
  longitude: "خط الطول",
  accuracy: "دقة",
  timestamp: "الطابع الزمني",
  device_id: "معرف الجهاز",
  active: "نشط",
  o_clock: "ساعة",
  loading: "دكان",
  annotation: "ملاحظه",
  since: "منذ",
  camera: "كاميرا",
  map: "بطاقة",
  gallery: "معرض",
  work: "عمل",
  employees: "زميل",
  login: "Anmeldung",
  login_action: "أعلن",
  calendar_week_abbreviation: "كيه دبليو",
  calendar: "تقويم",
  to_call: "دعا",
  email: "البريد الإلكتروني",
  attachment: "التذييل",
  operational_planning: "الخطة التشغيلية",
  to_scan: "مسح ضوئي",
  download: "تحميل",
  export: "تصدير",
  to_document: "مستند",
  checklist: "قائمه",
  checklists: "قوائم",
  password: "شعار",
  confirmation: "تأكيد",
  confirm: "أكد",
  confirmation_email: "تأكيد",
  unknown: "مجهول",
  unknown_place: "الموقع غير معروف",
  unknown_plan: "جدول الورديات غير المسمى",
  project_no: "رقم المشروع",
  project_file: "ملف المشروع",
  contact_person: "الاتصال",
  overtime: "العمل الاضافي",
  timesheet: "الجدول الزمني",
  minustime: "ناقص ساعات",
  back: "ظهر",
  undo: "تراجعيه",
  clockout: "الخروج",
  clocked_out: "مختومة",
  clockin: "الختم في",
  clocked_in: "ختمها",
  dismiss: "أجهض",
  discard: "رفض",
  finish: "جاهز",
  or: "أو",
  copy: "نسخ",
  qr_code: "رمز ريال قطري",
  documentation: "تتبع الوقت والتوثيق",
  attendance: "محطة الكمبيوتر اللوحي",
  tiercontent: "محتويات العبوة",
  start_now: "هيا بنا نبدأ",
  skip: "تخطي",
  logout_during_core_time: "مختوم خلال الوقت الأساسي",
  absent_during_core_time: "غائب خلال الوقت الأساسي",
  distance: "المسافة",
  km_reading: "المسافة المقطوعة",
  the_start: "بدء",
  the_end: "انتهاء",
  license_plate: "لوحة الترخيص",
  details: "التفاصيل",
  hide: "إخفاء",
  cost: "التكاليف",
  file: "ملف",
  address_book: "دفتر العناوين",
  template_plural: "قوالب",
  signature: "توقيع",
  main_project: "أحسن",
  main_projects: "المشاريع الرئيسية",
  sub_projects: "المشاريع الفرعية",
  scan_to_login_header: "تسجيل رمز الاستجابة السريعة",
  description: "وصف",
  project_location: "موقع المشروع",
  phone_number: "رقم الهاتف",
  project_info: "مشروع",
  number_short: "لا.",
  sketch: "Sketch",
  video: "فيديو",
  delete: "حذف",
  send: "إرسال",
  sending: "ارسل...",
  save: "أنقذ",
  granted: "مصدق",
  pending: "طلب",
  denied: "انخفض",
  customer: "زبون",
  mobile_number: "رقم الهاتف",
  ok: "موافق",
  day: "يوم",
  tomorrow: "الصباح",
  days: "أيام | يوم | أيام | أيام",
  holidays: "العطل",
  vacation_days: "العطل",
  vacation_hours: "ساعات الإجازة",
  request: "تطبيق",
  accept: "تقبل",
  withdraw: "سحب",
  hour_account: "حساب بالساعة",
  period: "مرحلة زمنية",
  to: "حتى",
  date: "موعد",
  number: "رقم",
  message: "رسالة",
  change: "تغيير",
  changed: "تغيير",
  changed_fields: "المجالات التي غيرت",
  type: "نوع",
  hour: "ساعة",
  hours: "الساعات",
  hours_abbreviation: "قياسي.",
  hours_with_amount: "{amount} الساعات",
  end: "أنهى",
  end_date: "أنهى",
  start_date: "بدء",
  absence: "غياب",
  month: "شهر",
  week: "أسبوع",
  transcript: "نسخه",
  time_left: "باق",
  transcript_tasks: "المهام",
  add_task: "الجديد",
  /** Differentiation in some languages (e.g. English) */
  from: "من",
  of: "من",
  of_hours: "من {hours} الساعات",
  of_hours_abbreviation: "{hours} من ساعات",
  /**************/

  used: "مستعمل",
  update: "تحديث",
  today: "اليوم",
  correction: "تصحيح",
  work_time: "وقت العمل",
  break: "تورع",
  loading_time: "تحميل",
  driving_time: "مدة الرحلة",
  business_trip: "دورة العمل",
  project: "مشروع",
  special_one: "سوندر1",
  special_two: "سوندر2",
  clock: "ساعة",
  search: "بحث",
  operation: "نشاط",
  day_protocol: "دقائق اليوم",
  continue: "أبعد",
  total_duration: "مجموع",
  duration: "مدة",
  hello: "مرحبا",
  close: "غلق",
  comment: "التعليق",
  small: "صغير",
  medium: "متوسط",
  large: "كبير",
  sharpie: "دبوس",
  line: "سطر",
  arrow: "سهم",
  rectangle: "مستطيل",
  ellipse: "إهليلج",
  text: "نص",
  language_settings: "اللغة",
  clock_reminder: "تذكير بالطابع",
  individually: "فرد",
  from_o_clock: "من",
  to_o_clock: "حتى",
  eraser: "مساحة",
  edit: "حرر",
  legal_notes: "قانوني",
  notes: "تلاحظ",
  note: "ملاحظه",
  imprint: "بصمه",
  open_source_licenses: "شروط ترخيص المصدر المفتوح",
  author: "كاتب",
  license_type: "ترخيص",
  version: "الإصدار",
  substitute: "التمثيل",
  not_rated: "غير مصنف",
  weekly_working_hours: "ساعات العمل الأسبوعية",
  show_less: "اعرض أقل",
  office_center: "مركز المكاتب",
  admin_view: "إدارة NFC",
  register: "سجل",
  shifts: {
    shift_attachments: "الملحقات (طبقة)",
    shift_plan_attachments: "الملحقات (خطة الوردية)",
    shift_plan: "جدول الورديات",
    shift: "طبقة"
  },
  absences: {
    sick: "المرض (استمرار دفع الأجور)",
    vacation: "عيد",
    workshop: "ندوة/دورة",
    special_vacation: "إجازة خاصة",
    school: "مدرسة",
    working_time_account: "حساب وقت العمل",
    holiday: "عيد",
    other: "آخر",
    driving_time: "مدة الرحلة",
    parental_leave: "الإجازة الوالدية",
    excused_absent: "مفقود معذور (مدفوع)",
    not_excused_absent: "التغيب بدون عذر",
    sick_industrial_accident: "المرض في حادث العمل (LFZ)",
    short_time_work: "العمل لوقت قصير (Kug)",
    maternity_pay: "إجازة الأمومة/حظر العمل",
    sick_child: "رعاية طفل مريض مع بدل مرض (يومي)",
    sick_child_no_payment: "رعاية طفل مريض بدون بدل مرض (يومي)",
    vacation_no_payment: "إجازة بدون أجر",
    sick_before_short_time_work: "الأجر المرضي / المرض قبل Kug",
    weather_related_failure: "الفشل المرتبط بالطقس",
    sick_short_time_work: "المرض أثناء الكوج",
    sick_no_payment: "المرض (دون استمرار دفع الأجور)",
    company_vacation: "العطل",
    meals_14_euro: "بدل تموين صغير",
    meals_28_euro: "بدل طعام كبير"
  },
  image_editor: {
    font_size: "حجم النوع",
    stroke_width: "وزن الخط",
    stroke_color: "لون",
    text_color: "لون",
    rotate_left: "استدارة إلى اليسار",
    rotate_right: "استدارة إلى اليمين",
    flip_horizontal: "اقلب أفقيا",
    flip_vertical: "الوجه عموديا"
  },
  travel_log: {
    method_of_transportation: "وسائل النقل",
    company_car: "سيارة الشركة",
    private_car: "سيارة خاصة",
    rental_car: "استئجار سيارة",
    taxi: "تاكسي",
    public_transportation: "وسائل النقل العام",
    airplane: "الطائرة",
    train: "السكك الحديدية (النقل العام للمسافات الطويلة)",
    other: "أخرى",
    km_reading_start: "بدء المسافة المقطوعة",
    km_reading_end: "نهاية المسافة المقطوعة",
    net_expenses: "نفقات السفر (الصافي)",
    tax: "ضريبة القيمة المضافة"
  },
  read_in: "اقرأ في",
  currency: "العملة",
  reason: "السبب",
  label: "تسميه",
  monday: "الاثنين",
  tuesday: "الثلاثاء",
  wednesday: "الأربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
  sunday: "الأحد",
  break_alarm: "كسر منبه الساعة",
  clockin_reminder: "تذكير بتسجيل الدخول",
  clockout_reminder: "تذكير بإلغاء الاشتراك"
};